import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-by-column.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-by-column.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AlertType } from "../../../models/alert";
import { AppControllerService } from "../../../../app-controller.service";
import { SharedConstants } from "../../../constants/shared.constants";
import { PropertiesAdvancedSearchHostDirective } from "../../../../tabs/properties/shared/directives/properties-advanced-search-host.directive";
import { SearchTableService } from "../../../services/table-column-mapping/search-table.service";
import { PropertyService } from "../../../../tabs/properties/shared/services/property.service";
import { AutoUnsub } from "../../../decorators/autounsub.decorator";
let SearchByColumnComponent = class SearchByColumnComponent {
    changeDetectorRef;
    appControllerService;
    componentFactoryResolver;
    propertyService;
    searchTableService;
    propertiesAdvancedSearchHostDirective;
    searched = new EventEmitter();
    advancedSearchOccurred = new EventEmitter();
    searchPlaceHolder;
    showSearchButton;
    placeHolder;
    preSelected;
    searchDebounce;
    selectedColumn;
    searchText;
    searchByOptions;
    label = SharedConstants.SEARCH_PREFIX;
    isSimpleSearch = true;
    isCemeterySearch = false;
    propertySearchCallback;
    listenForSearchOptionChangesSubscription;
    constructor(changeDetectorRef, appControllerService, componentFactoryResolver, propertyService, searchTableService) {
        this.changeDetectorRef = changeDetectorRef;
        this.appControllerService = appControllerService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.propertyService = propertyService;
        this.searchTableService = searchTableService;
    }
    ngOnInit() {
        this.searchByOptions = new Array();
        this.listenForSearchOptionChanges();
        this.placeHolder = this.placeHolder === "" ? (this.searchPlaceHolder ? this.searchPlaceHolder : SharedConstants.SEARCH_BY_DEFAULT) : this.placeHolder;
        if (this.selectedColumn === "")
            this.selectedColumn = this.placeHolder;
        this.searchTextChanged(this.selectedColumn);
    }
    listenForSearchOptionChanges() {
        this.listenForSearchOptionChangesSubscription = this.searchTableService.propertySearchOptionsAsObservable.subscribe((searchOptions) => {
            if (searchOptions.length > 0) {
                this.searchByOptions = [];
                this.searchByOptions.push(...searchOptions);
                this.changeDetectorRef.detectChanges();
            }
        });
    }
    search($event) {
        if (this.selectedColumn === this.placeHolder) {
            this.appControllerService.showMessage(SharedConstants.NO_SEARCH_SELECTED_MESSAGE, AlertType.Warning);
        }
        if (!$event) {
            $event = "";
        }
        this.searchText = "";
        const search = { text: $event, column: this.selectedColumn };
        this.searched.emit(search);
        this.changeDetectorRef.markForCheck();
    }
    onClickSearch($event) {
        if (!$event || $event.trim() === "") {
            this.appControllerService.showMessage(`${SharedConstants.NO_SEARCH_TEXT_ENTERED_MESSAGE}`, AlertType.Warning);
        }
        else {
            this.search($event);
        }
    }
    searchTextChanged($event) {
        if (!this.showSearchButton) {
            if (!$event || $event.trim() === "") {
                this.appControllerService.showMessage(`${SharedConstants.NO_SEARCH_TEXT_ENTERED_MESSAGE}`, AlertType.Warning);
            }
            else {
                this.search($event);
            }
        }
    }
    searchByColumnChanged($event) {
        this.selectedColumn = $event;
        // @ts-ignore
        if (this.propertyService.advancedSearchComponentLookup && this.propertyService.advancedSearchComponentLookup.get($event)) {
            this.showAdvancedSearch($event);
        }
        else {
            this.isSimpleSearch = true;
            if (!this.showSearchButton) {
                const search = { text: this.searchText, column: this.selectedColumn };
                this.searched.emit(search);
            }
        }
        this.changeDetectorRef.markForCheck();
    }
    showAdvancedSearch($event) {
        // @ts-ignore
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.propertyService.advancedSearchComponentLookup.get($event));
        const createContainerRef = this.propertiesAdvancedSearchHostDirective.viewContainerRef;
        createContainerRef.clear();
        const componentRef = createContainerRef.createComponent(componentFactory);
        componentRef.instance.propertySearchCallback = this.advanceSearchHappened;
        this.isSimpleSearch = false;
    }
    advanceSearchHappened = (propertySearchCallback) => {
        // @ts-ignore
        this.advancedSearchOccurred.emit(propertySearchCallback);
    };
    static ctorParameters = () => [
        { type: ChangeDetectorRef },
        { type: AppControllerService },
        { type: ComponentFactoryResolver },
        { type: PropertyService },
        { type: SearchTableService }
    ];
    static propDecorators = {
        propertiesAdvancedSearchHostDirective: [{ type: ViewChild, args: [PropertiesAdvancedSearchHostDirective, { static: true },] }],
        searched: [{ type: Output }],
        advancedSearchOccurred: [{ type: Output }],
        searchPlaceHolder: [{ type: Input }],
        showSearchButton: [{ type: Input }],
        placeHolder: [{ type: Input }],
        preSelected: [{ type: Input }],
        searchDebounce: [{ type: Input }]
    };
};
SearchByColumnComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-by-column",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchByColumnComponent);
export { SearchByColumnComponent };
